import React, { useEffect, useState } from "react";
import "./index.css";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import Checkbox from "@material-ui/core/Checkbox";
import { blue } from "@material-ui/core/colors";
import { withStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import FiberManualRecordOutlinedIcon from "@material-ui/icons/FiberManualRecordOutlined";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import styles from "./TreeMapFile.module.css";
import Tree from "./DataObjectTreeNode";
import axios from "./../../../axios";
import { useTranslation } from "react-i18next";
import { Menu, MenuItem } from "@material-ui/core";
import { Edit, MoreVert } from "@material-ui/icons";
import deLink from "../../../Icons/deLink.svg";
import DataObjectEdit from "../../../Icons/DataObjectEdit.svg"
import DataObjectRight from "../../../Icons/DataObjectRight.svg"
import DataObjectDown from "../../../Icons/DataObjectDown.svg"
import DataObjectChecked from "../../../Icons/DataObjectsChecked"
import {
  getFormId,
  removeUniqueMapping,
  sendRequestForControl,
} from "../../IFormDesignerLayout/IFormDesignerLogic";
import { GetState, GetStateFromData } from "../../CustomHooks/CustomHooks";
import cloneDeep from "lodash-es/cloneDeep";
import { updateStateInRedux, useDispatch } from "../../../Redux";
import { checkIsAdvancedListviewChild, recursionMapping } from "../../IFormDesignerLayout/SectionLayoutLogic";

const GreenCheckbox = withStyles({
  root: {
    color: green[400],
    "&$checked": {
      color: green[600],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const BlueCheckbox = withStyles({
  root: {
    color: blue[400],
    "&$checked": {
      color: blue[600],
    },
  },
  checked: {},
})((props) => (
  <Checkbox
    color="default"
    {...props}
    aria-label="Data Objects"
    inputProps={{ "aria-label": "Data Objects" }}
  />
));

const translationStyles1 =
  window?.psh_configs?.selectedLanguage === "ar" ||
  window?.psh_configs?.selectedLanguage === "ar-SA";
const TreeNode = ({
  node,
  showMapButton,
  setShowMapButton,
  setDeLinkState,
  createNewElement,
  isWS,
  setSelectedContent,
  dataRef,
  setSelectedControl,
  selectedControl,
  openModifyDataObjMf = () => {
    console.log("provide fn for modify");
  },
  portalState,
}) => {
  const { t } = useTranslation();
  const contexts = GetStateFromData();
  const {
    openDrawer,
    setOpenLoader,
    drawerPinned,
    mappingControlsIdMap,
    setCurrentDataObjectJson,
    microFrontendData,
    currentMappedDO,
    activePage,
    formState2,
    updateJson,
    fetchDataObject,
    filteredDataObject,
    openCanvasForSubform,
    dataClassAdvacnceListview,
  } = contexts.contexts;

  const dispatch = useDispatch();
  const {dragDropDO} = GetState("dragDropDO");

  const { updatedComponentInFormState } = updateJson;
  const [childVisible, setChildVisiblity] = useState(node["children"] || node["MappingInfo"] ? true : false);
  const [isDOSelected, setIsDOSelected] = useState(false)

  const [renderInstant, setRenderInstant] = useState();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [mappedContentForAdvance, setMappedContentForAdvance] = React.useState([]);

  // function fetchingChildren(event, dataC) {
  //   setSelectedControl((prev) => (prev = dataC));
  //   if (dataRef) {
  //     dataRef.value = dataC;
  //   }
  //   var treeName = "";

  //   if (dataC?.treeName) {
  //     treeName = dataC?.treeName;
  //   }
  //   setChildVisiblity(!childVisible);
  //   var ab = 1;
  //   if (
  //     ab === 1 &&
  //     childVisible === false &&
  //     dataC.children === undefined &&
  //     dataC.MappingInfo
  //   ) {
  //     var currName = dataC.VariableName;
  //     var pName = dataC?.parentName ? dataC?.parentName + "." : "";
  //     var parentname = currName;
  //     fetch("/mdm-rest/app/gettabledefinition", {
  //       method: "post",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         id: dataC.VariableId,
  //         name: parentname,
  //         status: "1",
  //       }),
  //     })
  //       .then(function (response) {
  //         return response.json();
  //       })
  //       .then(function (content) {
  //         var data = JSON.stringify(content.data);
  //         const jsonData = {
  //           formId: activePage?.formId,
  //           data: `${data}`,
  //           treeName: treeName,
  //         };

  //         axios
  //           .post("/idesign/gettableDefinition", jsonData, {
  //             withCredentials: true,
  //           })
  //           .then((response) => {
  //             dataC.children = response.data.children;
  //             setRenderInstant(dataC);
  //           })
  //           .catch(function (error) {
  //             if (error.response) {
  //             }
  //             console.log("error is", error);
  //           });
  //       })
  //       .catch((err) => {
  //         console.log("error is", err);
  //       });
  //   }
  // }

  const handleOnMouseDown = () => {
    setIsDOSelected(true)
  }

  const handleOnMouseUp = () => {
    setIsDOSelected(false)
  }

  const handleDragEnd = () => {
    setIsDOSelected(false)
    if(!dragDropDO){
      setCurrentDataObjectJson(cloneDeep({}));
    }
  }
  
  const fetchingAllDataObjects = async (dataC) => {
    setSelectedControl(() => dataC);
    if (dataRef) {
        dataRef.value = dataC;
      }
    setChildVisiblity(!childVisible);
    var ab = 1;
    if (
      ab === 1 &&
      childVisible === false &&
      dataC.children === undefined &&
      dataC.MappingInfo
    ) {
    window.loading(true)
    const parentname = dataC?.VariableName

    const jsonData = {
      parentTableId: dataC ? (dataC?.VariableId ? dataC?.VariableId : "") : "",
      treeName: parentname || "",
      status: "1",
      formId: getFormId().toString()
    }

    await axios
    .post("/idesign/gettableDefinition", jsonData, {
      withCredentials: true,
    })
    .then((response) => {
      dataC.children = response.data.children;
      setRenderInstant(dataC);
    })
    .catch((error) => {
      if(error.response){
        console.log("error", error.response)
      }
      console.log("error", error)
    })
    window.loading(false)
  }
}

  function closeDrawerWhileDraggingAndNotPinned(node) {
    setCurrentDataObjectJson(node);
    if (drawerPinned === false) {
      if (openDrawer === true) {
      }
    }
  }

  function dragDropDuplicateDataObject(event, node){
    event.preventDefault()
    setCurrentDataObjectJson(node);
    if (drawerPinned === false) {
      if (openDrawer === true) {
      }
    }
  }
  useEffect(() => {
    if(dataClassAdvacnceListview){
      var tempData = [];
      recursionMapping(filteredDataObject, tempData, dataClassAdvacnceListview);
      setMappedContentForAdvance(tempData);
    }
  }, [filteredDataObject])

  const hasChild =
    (node.children && node.children?.length !== 0) || node["MappingInfo"]
      ? true
      : false;

  const isAdvanceListview = (node) => {
    if (
      node.Unbounded === "Y" &&
      node?.children &&
      node?.children?.length > 1
    ) {
      for (let item of node?.children) {
        if (item?.children && item?.children?.length > 1) {
          return true;
        }
      }
      return false;
    }
  };

  const elementTypeOfNode =
    node["VariableType"] === "Date" ||
    node["VariableType"] === "shortDate" ||
    node["VariableType"] === "Short Date"
      ? "datepick"
      : isAdvanceListview(node)
      ? "advancelistview"
      : node["Unbounded"] === "Y" && node.children
      ? "listview"
      : node["Unbounded"] === "Y" && !node.children
      ? "listbox"
      : node["Unbounded"] === "N" && node?.children?.length > 0
      ? "section"
      : node["Unbounded"] === "N" && node["VariableType"] === "Boolean"
      ? "toggle"
      : "textbox";

  var inputStyle = {};

  var inputStyleForParent = {
    backgroundColor: "#0072C619",
  };

  const callModifyDataObjMf = (e) => {
    if (
      node.children &&
      node.children.length > 0 &&
      (node.dataObjectType === "M" || node.dataObjectType === "P")
    ) {
      openModifyDataObjMf(node);
    }
    e.stopPropagation();
    handleClose();
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    event.stopPropagation();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };


function parentUnbounded(parentObject) {
  if (
    openCanvasForSubform === "advanceListviewFromScratch" &&
    !parentObject.isMapped &&
    !currentMappedDO.includes(parentObject.treeName)
  ) {
    return true;
  } else if (
    openCanvasForSubform === "advanceListviewFromScratch" &&
    (parentObject.isMapped || currentMappedDO.includes(parentObject.treeName))
  ) {
    return false;
  } else if (parentObject.Unbounded === "Y") {
    return true;
  } else {
    return parentObject.Unbounded === "Y";
  }
}
function findParentForChild(parentName, objects) {
  for (const obj of objects) {
    if (obj.VariableName === parentName || obj?.treeName === parentName) {
      return parentUnbounded(obj);
    } else {
      if (obj.children) {
        for (const child of obj.children) {
          if (child.VariableName === parentName || child?.treeName === parentName) {
            return parentUnbounded(child); // Return true/false
          } else if (child.children) {
            const result = findParentForChild(parentName, child.children);
            if (result !== null) {
              return result; // Return true/false from deeper levels
            }
          }
        }
      }
    }
  }
  return null; // Child not found
}

const isParentUnbounded = findParentForChild(node?.parentName, filteredDataObject)

const isAdvancedListviewChild = checkIsAdvancedListviewChild(mappedContentForAdvance[0], node?.treeName)

const isSubform = () => {
  if (openCanvasForSubform === "advanceListviewFromScratch" || openCanvasForSubform === "subform") {
    return node?.children?.some((child) => Array.isArray(child?.children) && child.children.length > 0) || false;
  }
  return false;
};

const isDraggable = () => {
  if (dataClassAdvacnceListview && !isAdvancedListviewChild){
    return false
  } else if (dataClassAdvacnceListview && isAdvancedListviewChild){
    return true
  } else if(!isWS && !isParentUnbounded && !isSubform()){
    return true
  } else {
    return false
  }
}

  return (
    <li className={node?.parentName === "" ? styles.mainParent : styles.parentChild} id={node["treeName"]}>
      <div
        key={node["treeName"]}
        style={
          isWS && selectedControl?.treeName === node["treeName"]
            ? inputStyleForParent
            : inputStyle
        }
        onClick={(event) => fetchingAllDataObjects(node)}
        onMouseDown={() => handleOnMouseDown()}
        onMouseUp={() => handleOnMouseUp()}
        onDrag={
          (!mappingControlsIdMap.has(node["treeName"]) || node["isMapped"] !== true) && !isWS
            ? () => closeDrawerWhileDraggingAndNotPinned(node)
            : (ev) => dragDropDuplicateDataObject(ev, node)
        }
        onDragStart={createNewElement}
        onDragEnd={() => handleDragEnd()}
        className={
          (node["isMapped"] === true ||
          currentMappedDO.includes(node["treeName"])) && !isWS
            ? `d-flex checkedDataObjectContainer`
            : (isParentUnbounded || isSubform() || (dataClassAdvacnceListview && !isAdvancedListviewChild)) ? `d-flex ${styles.notDraggble} dataObjectBox` 
            : isDOSelected ? "d-flex dataObjectBox dataObjectBox_Selected" : "d-flex dataObjectBox"
        }
        inptype={elementTypeOfNode}
        draggable={isDraggable()}
      >
        {hasChild && (
          <div>
            {childVisible ? (
              <span className={styles.iconStyle}>
                {" "}
                {/* <ExpandMoreIcon /> */}
                <img
                  src={DataObjectDown}
                  alt="Down Icon"
                />
              </span>
            ) : (
              <span className={styles.iconStyle}>
                {/* <ChevronRightIcon /> */}
                <img
                src={DataObjectRight}
                alt="Right Icon"
              />
              </span>
            )}
          </div>
        )}
        {!hasChild && (
          <div>
            <span></span>
          </div>
        )}
        {/* {!hasChild ? <>&nbsp;&nbsp;&nbsp; &nbsp;</> : <>&nbsp;</>} */}

        <span
          className={
            (node.children && node.children?.length !== 0) ||
            node["MappingInfo"]
              ? (isParentUnbounded || isSubform() || (dataClassAdvacnceListview && !isAdvancedListviewChild)) && !isWS
                ? `${styles.parentNameStyle} ${styles.notDraggble}`
                : `${styles.parentNameStyle}`
              : (isParentUnbounded || isSubform() || (dataClassAdvacnceListview && !isAdvancedListviewChild)) && !isWS
              ? `${styles.notDraggble} ${styles.variableNameStyle}`
              : styles.variableNameStyle
          }
          title={node["VariableName"]}
        >
          {" "}
          {node["VariableName"]}{" "}
        </span>
        &nbsp;
        <div style={{marginLeft: "auto", marginRight: "8px"}}>
          {node["isMapped"] === true ||
          currentMappedDO.includes(node["treeName"]) ? (
            <>
              <span
                style={{
                  marginLeft: translationStyles1 ? "6px" : "-3px",
                  marginTop: "4px",
                }}
              >
              <DataObjectChecked isDraggable={
                !isWS && (isParentUnbounded || isSubform() || (dataClassAdvacnceListview && !isAdvancedListviewChild)) ? true 
                : false} />
              </span>
            </>
          ) : (
            <>
              <span
                style={{
                  marginLeft: translationStyles1 ? "6px" : "-3px",
                  marginTop: "4px",
                }}
              >
              </span>
            </>
          )}
          {portalState === "Portals" && (
            <>
              {node.children && node.children?.length !== 0 && (
                <span
                  style={{
                    marginLeft: "auto",
                    marginTop: "3px",
                    cursor: "pointer",
                  }}
                >
                  <MoreVert onClick={handleClick} />
                </span>
              )}
            </>
          )}
        </div>
        <Menu
          id="modifyMf_FocusableDiv"
          anchorEl={anchorEl}
          keepMounted
          open={open}
          onClose={handleClose}
          MenuListProps={{ disablePadding: true }}
          PaperProps={{
            style: {
              width: "100px",
              marginTop: "32px",
              marginLeft: "-14px",
              height: "auto",
            },
          }}
        >
          <MenuItem onClick={callModifyDataObjMf}>
            <img
                src={DataObjectEdit}
                style={{ marginRight: ".5rem" }}
                alt="Edit Icon"
              />
              {t("Edit")}
          </MenuItem>
          {microFrontendData?.applicationId &&
            (microFrontendData?.status === "draft" ||
              microFrontendData?.status === "L") && (
              <MenuItem
                onClick={() => {
                  removeUniqueMapping(node, formState2);
                  const extraDetails = {
                    treeName: node?.treeName,
                    formId: microFrontendData?.defaultFormId,
                  };
                  sendRequestForControl(
                    undefined,
                    "deLink",
                    undefined,
                    extraDetails
                  )
                    .then((res) => {
                      node.isMapped = false;
                      setDeLinkState(true);
                      window.updateDataObject = true;
                      fetchDataObject();
                      setOpenLoader(false);
                    })
                    .catch((err) => {
                      setOpenLoader(false);
                      window.loading(false)
                    });
                  updatedComponentInFormState();
                }}
              >
                <img
                  src={deLink}
                  style={{ marginRight: ".5rem" }}
                  alt="Delink Icon"
                />{" "}
                {t("De-Link")}
              </MenuItem>
            )}
        </Menu>
      </div>

      {hasChild && childVisible && (
        <div className="d-tree-content" style={{marginLeft: "12px"}}>
          <ul className="d-flex d-tree-container flex-column">
            <Tree
              data={node["children"]}
              showMapButton={showMapButton}
              setShowMapButton={setShowMapButton}
              createNewElement={createNewElement}
              isWS={isWS}
              setSelectedContent={setSelectedContent}
              selectedControl={selectedControl}
              setSelectedControl={setSelectedControl}
              dataRef={dataRef}
              setDeLinkState={setDeLinkState}
              openModifyDataObjMf={openModifyDataObjMf}
            />
          </ul>
        </div>
      )}
    </li>
  );
};

export default TreeNode;
